import _taggedTemplateLiteral from "/builds/M9cfiv79/0/everlywell/apps/www/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18;

import { css } from "styled-components";
var breakpoints = {
  forPhoneOnly: 599,
  forTabletVerticalUp: 600,
  forTabletVerticalDown: 899,
  forTabletHorizontalUp: 900,
  forTabletHorizontalDown: 1199,
  forDesktopUp: 1200,
  forDesktopDown: 1799,
  forBigDesktopUp: 1800
},
    mediaQueries = {
  forPhoneOnly: "@media screen and (max-width: ".concat(breakpoints.forPhoneOnly, "px)"),
  forTabletVerticalUp: "@media screen and (min-width: ".concat(breakpoints.forTabletVerticalUp, "px)"),
  forTabletVerticalDown: "@media screen and (max-width: ".concat(breakpoints.forTabletVerticalDown, "px)"),
  forTabletHorizontalUp: "@media screen and (min-width: ".concat(breakpoints.forTabletHorizontalUp, "px)"),
  forTabletHorizontalDown: "@media screen and (max-width: ".concat(breakpoints.forTabletHorizontalDown, "px)"),
  forDesktopUp: "@media screen and (min-width: ".concat(breakpoints.forDesktopUp, "px)"),
  forDesktopDown: "@media screen and (max-width: ".concat(breakpoints.forDesktopDown, "px)"),
  forBigDesktopUp: "@media screen and (min-width: ".concat(breakpoints.forBigDesktopUp, "px)")
},
    colors = {
  black: "#000000",
  white: "#ffffff",
  gray1: "#f5f5f5",
  gray2: "#dddddd",
  gray3: "#aaa9ac",
  gray4: "#444850",
  gray5: "#252228",
  teal1: "#eef5f6",
  teal2: "#b8dde1",
  teal3: "#95c6bf",
  teal4: "#5cb8b2",
  teal5: "#008b84",
  teal6: "#007377",
  green0: "#f5faf7",
  green1: "#edf5f1",
  green2: "#d6ebdd",
  green3: "#71ac85",
  green4: "#4ba373",
  green5: "#1e824c",
  green6: "#2a6b48",
  red1: "#fff0f0",
  red2: "#e56575",
  red3: "#c94557",
  red4: "#c6394c",
  orange1: "#e7936e",
  orange2: "#ef775b",
  orange3: "#c34f29",
  orange4: "#d86b47",
  blue1: "#006298",
  yellow1: "#ffca5f",
  yellow2: "#f6c97c"
},
    typographyBase = {
  type: {
    nexa: '"EW Nexa", "Helvetica Neue", Helvetica, Arial, sans-serif',
    code: '"SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace'
  },
  weight: {
    thin: "100",
    xlight: "200",
    light: "300",
    book: "400",
    regular: "500",
    bold: "600",
    xbold: "700",
    heavy: "800",
    black: "900"
  }
},
    size = {
  xs3: "2",
  xs2: "4",
  xs1: "8",
  sm: "12",
  md: "16",
  lg: "24",
  xl1: "32",
  xl2: "40",
  xl3: "48",
  xl4: "64",
  xl5: "80",
  xl6: "96",
  xl7: "128",
  xl8: "160",
  code: "90"
},
    heroText = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: ", ";\n  font-size: 2.886rem;\n  line-height: 3.5rem; /* 56px */\n  letter-spacing: -0.76px;\n\n  ", " {\n    font-size: 4.11rem;\n    line-height: 4.5rem; /* 72px */\n    letter-spacing: -0.89px;\n  }\n"])), colors.teal6, typographyBase.weight.bold, mediaQueries.forTabletVerticalUp),
    h1Text = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: ", ";\n  font-size: 2.281rem;\n  line-height: 2.75rem; /* 48px */\n  letter-spacing: -0.6px;\n\n  ", " {\n    font-size: 3.247rem;\n    line-height: 4rem; /* 64px */\n    letter-spacing: -0.86px;\n  }\n"])), colors.teal6, typographyBase.weight.bold, mediaQueries.forTabletVerticalUp),
    h2Text = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: ", ";\n  font-size: 2.027rem;\n  line-height: 3rem; /* 48px */\n  letter-spacing: -0.18px;\n\n  ", " {\n    font-weight: ", ";\n    font-size: 2.566rem;\n    line-height: 3.5rem; /* 56px */\n    letter-spacing: 0.51px;\n  }\n"])), colors.teal6, typographyBase.weight.regular, mediaQueries.forTabletVerticalUp, typographyBase.weight.regular),
    h3Text = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: ", ";\n  font-size: 1.602rem;\n  line-height: 2rem; /* 32px */\n  letter-spacing: 0.53px;\n\n  ", " {\n    font-weight: ", ";\n    font-size: 2.027rem;\n    line-height: 2.5rem; /* 40px */\n    letter-spacing: 0.56px;\n  }\n"])), colors.teal6, typographyBase.weight.bold, mediaQueries.forTabletVerticalUp, typographyBase.weight.bold),
    h4Text = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: ", ";\n  font-size: 1.424rem;\n  line-height: 2rem; /* 32px */\n  letter-spacing: 0.47px;\n\n  ", " {\n    letter-spacing: 1px;\n  }\n"])), colors.teal6, typographyBase.weight.book, mediaQueries.forTabletVerticalUp),
    h5Text = css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: ", ";\n  font-size: 1.266rem;\n  line-height: 26px;\n  letter-spacing: 0.3px;\n"])), colors.teal6, typographyBase.weight.regular),
    overlineText = css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: ", ";\n  font-size: 0.889rem;\n  line-height: 1rem; /* 16px */\n  letter-spacing: 3.16px;\n  text-transform: uppercase;\n"])), colors.green5, typographyBase.weight.xbold),
    displayText = css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  color: ", ";\n  font-size: 1.424rem;\n  line-height: 2rem; /* 32px */\n  letter-spacing: 0;\n\n  ", " {\n    font-size: 2rem;\n    line-height: 3rem; /* 48px */\n    letter-spacing: 0.2px;\n  }\n"])), typographyBase.weight.book, colors.teal6, mediaQueries.forTabletVerticalUp),
    subtitle = css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  color: ", ";\n  font-size: 1.125rem;\n  line-height: 1.5rem;\n  letter-spacing: 0.45px;\n"])), typographyBase.weight.regular, colors.gray5),
    bodyText = css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  color: ", ";\n  font-size: 1.125rem;\n  line-height: 2rem; /* 32px */\n  letter-spacing: 0;\n"])), typographyBase.weight.book, colors.gray4),
    buttonText = css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  color: ", ";\n  font-size: 1.125rem;\n  line-height: 1.5rem; /* 24px */\n  letter-spacing: 0.3px;\n"])), typographyBase.weight.bold, colors.teal6),
    buttonTextSmall = css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  color: ", ";\n  font-size: 1rem;\n  line-height: 1.5rem; /* 24px */\n  letter-spacing: 0.27px;\n"])), typographyBase.weight.bold, colors.green5),
    disabledText = css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), colors.gray3),
    hintText = css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  ", "\n  ", "\n"])), bodyText, disabledText),
    bodyTextSmall = css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  color: ", ";\n  font-size: 1rem;\n  line-height: 1.75rem; /* 28px */\n  letter-spacing: 0;\n"])), typographyBase.weight.book, colors.gray4),
    bodyTextXSmall = css(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  color: ", ";\n  font-size: 0.875rem;\n  line-height: ", "px;\n  letter-spacing: 0;\n"])), typographyBase.weight.bold, colors.gray4, size.lg),
    errorText = css(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  font-size: 1rem;\n  color: ", ";\n"])), typographyBase.weight.bold, colors.red3),
    captionText = css(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  color: ", ";\n  font-size: 0.889rem;\n  line-height: 1.375rem; /* 22px */\n  letter-spacing: 0.71px;\n"])), typographyBase.weight.book, colors.gray4),
    typography = Object.assign(Object.assign({}, typographyBase), {
  heroText: heroText,
  h1Text: h1Text,
  h2Text: h2Text,
  h3Text: h3Text,
  h4Text: h4Text,
  h5Text: h5Text,
  overlineText: overlineText,
  displayText: displayText,
  subtitle: subtitle,
  bodyText: bodyText,
  bodyTextSmall: bodyTextSmall,
  bodyTextXSmall: bodyTextXSmall,
  buttonText: buttonText,
  buttonTextSmall: buttonTextSmall,
  disabledText: disabledText,
  hintText: hintText,
  errorText: errorText,
  captionText: captionText
}),
    transitions = {
  general: "0.15s ease-in-out"
},
    creditCardsIcons = {
  masterCard: "https://images.ctfassets.net/lrd5ir86ur94/14FLbzPYa4aleWD1E7pvUa/75a42e3c86e1bb0acc900d3d0dcbcbfb/Mastercard.png",
  visa: "https://images.ctfassets.net/lrd5ir86ur94/1yummzxHenvxPXyY3ecLvJ/1092906965ca9b72f38bd9d4ee816aad/Visa.png",
  americanExpress: "https://images.ctfassets.net/lrd5ir86ur94/1ex0hTkXy4QePFKRa3US2m/22b0ec234f75096ebae058ab6f089c94/American_Express.png",
  discover: "https://images.ctfassets.net/lrd5ir86ur94/1QMQbuqKj8bs46p1iWAplI/599259a9c10962fc82463428b250e505/Discover.png",
  payPal: "https://images.ctfassets.net/lrd5ir86ur94/EguYIuDNmAK2HlbfF6aPX/06e23d299fda67a800072ecb0c9513ec/PayPal_2x.png"
};
export { breakpoints, mediaQueries, colors, size, typography, transitions, creditCardsIcons };